import { render, staticRenderFns } from "./healthArticle.vue?vue&type=template&id=3dc226fe&scoped=true"
import script from "./healthArticle.vue?vue&type=script&lang=js"
export * from "./healthArticle.vue?vue&type=script&lang=js"
import style0 from "./healthArticle.vue?vue&type=style&index=0&id=3dc226fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc226fe",
  null
  
)

export default component.exports